import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'
import sliderIcon from '@/images/svg/slider.svg'

export default class Handle extends React.Component {
  render() {
    const {
      prefixCls, vertical, offset, style, disabled, min, max, value, tabIndex, ...restProps
    } = this.props

    const postionStyle = vertical ? { bottom: `${offset}%` } : { left: `${offset}%` }
    const elStyle = {
      ...style,
      ...postionStyle
    }
    let ariaProps = {}
    if (value !== undefined) {
      ariaProps = {
        ...ariaProps,
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      }
    }

    return (
      <Icon link={sliderIcon}
        ref={node => (this.handle = node)}
        role="slider"
        tabIndex= {disabled ? null : (tabIndex || 0)}
        {...ariaProps}
        {...restProps}
        style={elStyle}
        onBlur={this.handleBlur}
        onKeyDown={this.handleKeyDown}/>
    )
  }
}

Handle.propTypes = {
  prefixCls: PropTypes.string,
  className: PropTypes.string,
  vertical: PropTypes.bool,
  offset: PropTypes.number,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number,
  tabIndex: PropTypes.number
}
